import { DataService } from '../../../shared/services/data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ERToolService extends DataService<any> {

  httpClient: HttpClient;

  constructor(http: HttpClient) {
    super(`${environment.apiUrl.erToolService}`, http);
    this.httpClient = http;
  }

  //just an example
  getSomeData(): Observable<any> {
    return this.http.get<any>(`${this.url}`);
  }
  
  getMdlSasToken(
    sourceId, fileExportType, format,
    url: string = this.url + "GetMDL"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: { sourceId: sourceId, fileExportType: fileExportType, format: format },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getCountry(
    url: string = this.url + "GetCountry"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDataSourceFilter(
    url: string = this.url + "GetDataSourceFilter"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDrugData(
    dataSourceId: number,
    searchText: string,
    permanentQuarantine: boolean,
    countryId: number,
    selectedSearchCriteria: any,
    url: string = this.url + "ErtLandingScreen",
  ): Observable<any> {
    let params: any = {
      dataSourceId: dataSourceId,
      permanentQuarantine: permanentQuarantine,
      country_id: countryId,
    };
    if (!selectedSearchCriteria) {
      selectedSearchCriteria = { value: 'drugName' };
    }
    // Add search parameter based on selectedSearchCriteria
    switch (selectedSearchCriteria.value) {
      case 'drugName':
        params.name = searchText;
        break;
      case 'drugNumber':
        params.ndc = searchText;
        break;
      case 'pdbid':
        params.pddbId = searchText;
        break;
      case 'tcgid':
        params.tcgId = searchText;
        break;
      case 'genericNumber':
        params.genericNumber = searchText;
        break;
      default:
        params.ndc = searchText; // Default to NDC
    }

    return this.httpClient.get(url, {
      params: params,
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });

  }

  getSearchDrugData(
    dataSourceId: number,
    ndcOrName: string,
    country_id: number,
    pageNo: number,
    pageSize: number,
    selectedSearchCriteria: any,
    drugNameType?: number,
    url: string = this.url + "SearchDrug"
  ): Observable<any> {
    let params: any = {
      dataSourceId: dataSourceId,
      country_id: country_id,
      pageNo: pageNo,
      pageSize: pageSize
    }
    if (!selectedSearchCriteria) {
      selectedSearchCriteria = { value: 'drugName' };
    }
    // Add search parameter based on selectedSearchCriteria
    switch (selectedSearchCriteria.value) {
      case 'drugName':
        params.name = ndcOrName;
        // Add drugNameType if drugName is selected
        if (drugNameType !== undefined) {
          params.drugNameType = drugNameType;
        }
        break;
      case 'drugNumber':
        params.ndc = ndcOrName;
        break;
      case 'pdbid':
        params.pddbId = ndcOrName;
        break;
      case 'tcgid':
        params.tcgId = ndcOrName;
        break;
      case 'genericNumber':
        params.genericNumber = ndcOrName;
        break;
      default:
        params.ndc = ndcOrName; // Default to NDC
    }

    return this.httpClient.get(url, {
      params: params,
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });

  }
 

  getSearchDrugDataV1(
    dataSourceId: number,
    searchText: string,
    selectedSearchCriteria: any,
    country_id: number,
    pageNo: number,
    pageSize: number,
    drugNameType?: number,
    url: string = this.url + "SearchDrug"
  ): Observable<any> {

    let params: any = {
      dataSourceId: dataSourceId,
      country_id: country_id,
      pageNo: pageNo,
      pageSize: pageSize
    };

    // Add search parameter based on selectedSearchCriteria
    switch (selectedSearchCriteria.value) {
      case 'drugName':
        params.name = searchText;
        if (drugNameType !== undefined) {
          params.drugNameType = drugNameType;
        }
        break;
      case 'drugNumber':
        params.ndc = searchText;
        break;
      case 'pdbid':
        params.pddbId = searchText;
        break;
      case 'tcgid':
        params.tcgId = searchText;
        break;
      case 'genericNumber':
        params.genericNumber = searchText;
        break;
      default:
        params.ndc = searchText; // Default to NDC
    }

    return this.httpClient.get(url, {
      params: params,
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDrugDetailsByNdc(
    ndc: any,
    dataSourceId: number,
    url: string = this.url + "GetDrugByNDC"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        ndc: ndc,
        dataSourceId: dataSourceId
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDrugSourceByNDC(
    ndc: any,
    url: string = this.url + "GetDrugSources"
  ): Observable<any> {
    return this.httpClient.get(url + "?search=" + ndc, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getImages(
    ndc: string,
    id: number,
    url: string = this.url + "SliderImage"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        ndc: ndc,
        id: id
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  
 
}
